<header class="header">
    <div class="header-top">
        <div class="container">
            <div class="header-left">
                <div class="header-call-us">
                    <span>CALL US NOW </span><br>
                    <strong>{{ storeInfo?.PhoneNo }}</strong>
                </div>
            </div>
            <div class="container header-search header-search-bar">
                <input type="search" class="form-control" name="q" id="q" placeholder="Search product by name,brand..."
                    required="" [(ngModel)]="searchString" (keyup.enter)="searchTerm()">
                <div>

                    <app-dropdown [list]="allCategories" displayField="CategoryName" childListFledName="SubCategoryList"
                        displayChildField="CategoryName" [(selectedItem)]="selectedCategory"
                        placeHolder="All Categories" [selectedItem]="selectedCategory"
                        (selectedItemChange)="searchTerm()"></app-dropdown>
                </div>
                <button class="btn" type="button" (click)="searchTerm()"><i class="icon-search"></i></button>
            </div>
            <div class="header-right">
                <p class="welcome-msg">{{ user ? 'Welcome '+ user.FirstName+' '+user.LastName : 'Welcome Guest!' }}</p>
                <div class="header-dropdown dropdown-expanded">
                    <a>Links</a>
                    <div class="header-menu">
                        <ul>
                            <li *ngIf="user"><a [routerLink]="['/account']">MY ACCOUNT </a></li>
                            <li><a [routerLink]="['/contact-us']">Contact</a></li>
                            <li *ngIf="!user&&!IsHidePrice"><a [routerLink]="['/authentication']"
                                    class="login-link">SIGN IN</a></li>
                            <li *ngIf="user"><a class="login-link cursor-pointer" (click)="signOut()">SIGN OUT</a></li>
                            <li></li>
                        </ul>
                    </div><!-- End .header-menu -->
                </div><!-- End .header-dropown -->
                <div class="header-dropdown mr-auto">
                    <a class="pl-0 selected-store">{{ tokenManagerService?.appConfiguration?.StoreName }}</a>
                    <div class="header-menu">
                        <ul>
                            <li *ngFor="let store of stores" (click)="changeStore(store)"><a>{{ store.StoreName }}</a>
                            </li>
                        </ul>
                    </div>
                    <!-- End .header-menu -->
                </div>
            </div><!-- End .header-right -->
        </div><!-- End .container -->
    </div><!-- End .header-top -->

    <div class="header-middle sticky-header">
        <div class="container">
            <div class="header-left">
                <a [routerLink]="['/']" class="logo">
                    <img [src]="storeInfo?.CompanyLogo" alt="Porto Logo">
                </a>
                <nav class="main-nav">
                    <ul class="menu sf-arrows">
                        <li class="active"><a [routerLink]="['/']" routerLinkActive="active">Home</a></li>
                        <li *ngFor="let category of categories" [ngClass]="{'active':category.isActive}"
                            class="cursor-pointer">
                            <a (click)="navigateOnCategory(category)"
                                [ngClass]="{'sf-with-ul':category.SubCategoryList && category?.SubCategoryList?.length > 0}">{{
                                category.CategoryName }}</a>
                            <div class="megamenu megamenu-fixed-width"
                                *ngIf="category.SubCategoryList && category?.SubCategoryList?.length > 0">
                                <div class="row">
                                    <div class="col-lg-8">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <ul>
                                                    <li *ngFor="let subCategory of category.SubCategoryList">
                                                        <a class="cursor-pointer"
                                                            [routerLink]="['/search',subCategory.CategoryName]"
                                                            [queryParams]="{ name:subCategory.CategoryName, id:subCategory.CategoryEncryptedId,type:'subcategory'}">
                                                            {{ subCategory.CategoryName }}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-4">
                                        <div class="banner">
                                            <a>
                                                <img [src]="category.CategoryImage" alt="Menu banner">
                                            </a>
                                        </div><!-- End .banner -->
                                    </div><!-- End .col-lg-4 -->
                                </div>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>

            <div class="header-right">
                <button class="mobile-menu-toggler" type="button">
                    <i class="icon-menu"></i>
                </button>
                <div class="dropdown cart-dropdown">
                    <!-- <a class="dropdown-toggle cursor-pointer " role="button">
                        <span class="cart-count">{{ userCart?.AddToCartDetailList?.length || 0 }}</span>
                    </a> -->

                    <div class="dropdown-menu" *ngIf="userCart?.AddToCartDetailList">
                        <div class="dropdownmenu-wrapper">
                            <div class="dropdown-cart-products">
                                <div class="product" *ngFor="let product of userCart?.AddToCartDetailList">
                                    <div class="product-details">
                                        <h4 class="product-title">
                                            <a>{{ product.ProductName }}</a>
                                        </h4>

                                        <span class="cart-product-info">
                                            <span class="cart-product-qty">{{ product.Qty }}</span>
                                            x {{ CurrencySymbol }}{{ product.SalesPrice }}
                                        </span>
                                    </div><!-- End .product-details -->

                                    <figure class="product-image-container">
                                        <a class="product-image">
                                            <img [src]="product.ProductImage" alt="product">
                                        </a>
                                    </figure>
                                </div><!-- End .product -->
                            </div><!-- End .cart-product -->

                            <div class="dropdown-cart-total">
                                <span>Total</span>

                                <span class="cart-total-price">{{ CurrencySymbol }}{{ userCart?.OrderTotal }}</span>
                            </div><!-- End .dropdown-cart-total -->

                            <div class="dropdown-cart-action">
                                <a [routerLink]="['/cart']" class="btn">View Cart</a>
                                <a [routerLink]="['/checkout']" class="btn">Checkout</a>
                            </div><!-- End .dropdown-cart-total -->
                        </div><!-- End .dropdownmenu-wrapper -->
                    </div><!-- End .dropdown-menu -->
                </div><!-- End .dropdown -->
            </div><!-- End .header-right -->
        </div><!-- End .container -->
    </div><!-- End .header-middle -->
</header><!-- End .header -->